import React from 'react';

import { AccountInfoTitle, AccountInfoWrapper } from './account-info.styles';
import { ACCOUNT_INFO_METRICS_CONFIG, ACCOUNT_INFO_TITLE, ALL_METRICS } from './account-info.constants';
import { AccountInfoMetric } from './account-info-metric';

interface AccountInfoProps {
    boardName?: string;
    boardData?: any[];
    loading?: boolean;
    isDesktop: boolean;
}

export const AccountInfo = ({
    boardName = null,
    boardData,
    loading = false,
    isDesktop,
}: AccountInfoProps) => (
    <AccountInfoWrapper>
        <AccountInfoTitle>{ACCOUNT_INFO_TITLE[boardName] || null}</AccountInfoTitle>
        {
            boardData.map(metric => (
                <AccountInfoMetric
                    key={metric.metric}
                    metricData={metric}
                    metricsConfig={ACCOUNT_INFO_METRICS_CONFIG[boardName] || ALL_METRICS}
                    loading={loading}
                    isDesktop={isDesktop}
                />
            ))
        }
    </AccountInfoWrapper>
);
